import { z } from 'zod'
import { optionalText } from './fields'

/** Backoffice user and workspace directory listing; the cursor is the last row's ID. */
export const adminDirectoryQuerySchema = z.object({
  search: optionalText(120),
  cursor: z.string().trim().min(1).max(100).optional(),
  limit: z.coerce.number().int().min(1).max(100).default(50),
})

export type AdminDirectoryQuery = z.infer<typeof adminDirectoryQuerySchema>

type BanCandidate = {
  banned?: boolean | null
  banExpires?: Date | null
}

type AdminCandidate = BanCandidate & {
  role?: string | null
}

/**
 * Better Auth checks bans only when a session is created, so existing sessions are
 * checked here. Like its sign-in check, a ban past its expiry no longer applies.
 */
export function isBannedUser(user: BanCandidate, now: number) {
  if (user.banned !== true) return false
  return user.banExpires == null || user.banExpires.getTime() >= now
}

export function isActiveAdminUser(user: AdminCandidate, now: number) {
  return user.role === 'admin' && !isBannedUser(user, now)
}
